import React from 'react'
import PropTypes from 'prop-types'

import { Layout } from '@/components/layout'
import Form from '@/components/Pages/SignUp/Form'
import { CSRF_COOKIE_NAME } from '@/utils/csrf'

const pageId = 'signUp'

export default function SignUpPage({ csrfToken }) {
  return (
    <Layout.Content standalone>
      <Form csrfToken={csrfToken} />
    </Layout.Content>
  )
}

export async function getServerSideProps(ctx) {
  return { props: { csrfToken: ctx?.req?.headers[CSRF_COOKIE_NAME] } }
}

SignUpPage.layoutProps = {
  pageId,
  standalone: true,
  shouldRobotsIndex: false,
}

SignUpPage.propTypes = {
  csrfToken: PropTypes.string,
}
